import LayoutColumn from './LayoutColumn';
export default LayoutColumn;
